import type { WidgetType } from "./types";

export interface WidgetDefinition {
  type: WidgetType;
  label: string;
  description: string;
  supportsHistory: boolean;
  isImplemented: boolean;
}

export const WIDGET_REGISTRY: WidgetDefinition[] = [
  {
    type: "state-value",
    label: "Estado por código",
    description: "Texto e cor definidos pelo operador para cada código publicado.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "number",
    label: "Numero grande",
    description: "Valor instantaneo com unidade opcional.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "led",
    label: "LED",
    description: "Estado ligado/desligado para sinais booleanos.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "gauge",
    label: "Velocimetro",
    description: "Indicador SVG com escala minima e maxima.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "availability",
    label: "Disponibilidade",
    description: "Disponibilidade operacional por estado ou atividade do sinal.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "utilization",
    label: "Disponibilidade do periodo",
    description: "Utilizacao, tempo rodando x parado e timeline por janela.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "production-status",
    label: "Status operacional",
    description: "Producao por estado ou movimento por atividade do sinal.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "production-kpi",
    label: "Producao / Lote",
    description: "Ritmo, total fisico ou lote com meta e reset analitico.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "progress",
    label: "Progresso",
    description: "Barra percentual para metas, lotes e rendimento.",
    supportsHistory: false,
    isImplemented: false,
  },
  {
    type: "line-chart",
    label: "Grafico de linha",
    description: "Serie temporal quando houver historico disponivel.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "bar-chart",
    label: "Grafico de barras",
    description: "Producao por periodo (delta por bucket) ao longo do tempo.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "multi-value",
    label: "Painel comparativo",
    description: "Varias grandezas da mesma unidade lado a lado (tensao L1/L2/L3).",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "multi-chart",
    label: "Grafico multisserie",
    description: "Varias series no mesmo eixo, para comparar fases ou pontos.",
    supportsHistory: true,
    isImplemented: true,
  },
  {
    type: "modbus-health",
    label: "Saude Modbus",
    description: "Quantos pontos do barramento estao ok, mudos ou em excecao.",
    supportsHistory: false,
    isImplemented: true,
  },
  {
    type: "tank",
    label: "Tanque / nivel",
    description: "Preenchimento entre minimo e maximo, com alarmes de baixo e alto.",
    supportsHistory: false,
    isImplemented: true,
  },
];
